import PageTitle from "../../components/PagesComponents/PageTitleSection/PageTitle";

const StudentRegistration = () => {
  return (
    <>
    <PageTitle pagetitle="ONLINE REGISTRATION" />
    <div className=''>
      
      
    </div>
    </>
  )
}

export default StudentRegistration